<adapt-universal-dashboard-element [name]="dashboardTitle"
                                   [disableClick]="(canConfigureTeam$ | async) === false"
                                   (headerClicked)="editTeamGuidance()"
                                   linkText="Define the team guidance"
                                   [contentCard]="isAlto">
    <div *adaptLoadingUntilFirstEmit="let content of content$">
        @if (content) {
            <div>
                <p [froalaView]="content"></p>
            </div>
        } @else {
            <adapt-call-to-action-inline>
                <p>Setting your team guidance allows you to define:</p>
                <ul class="list-content">
                    <li>Your team purpose</li>
                    <li>Your team vision</li>
                    <li>Resources your team uses</li>
                    <li>General team information</li>
                </ul>
                <ng-container *adaptIfAlto="false">
                    @if ((canConfigureTeam$ | async) === true) {
                        <button adaptCallToActionButton
                                adaptButtonIcon="edit"
                                (click)="editTeamGuidance()">
                            Define the team guidance
                        </button>
                    }
                </ng-container>
            </adapt-call-to-action-inline>
        }
    </div>
</adapt-universal-dashboard-element>
